import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import SuperAdminTable from "./Component/SuperAdminTable";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import moment from "moment";
import { Button, Modal } from "react-bootstrap";
import { FaSpinner } from "react-icons/fa";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as yup from "yup";

const SuperAdminList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();


  const location = useLocation();


  const passedState = location.state || null;
  console.log("passedState", passedState);

  useEffect(() => {
    dispatch(updateNavbarHeading(passedState !== null ? passedState?.text : "Manage Admin Requests"));
  }, [passedState]);

  const [searchTerm, setSearchTerm] = useState("");
  const [superAdminListData, setSuperAdminListData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [requisitionOption, setRequisitionOption] = useState([]);
  const [error, setError] = useState("");
  const [apiStatus, SetApiStatus] = useState(undefined);

  const columns = {
    TicketNumber: { text: "Ticket#", width: "90px", align: "center", visible: true },
    EmployeeName: { text: "Employee", align: "start", visible: true },
    RequisitionType: { text: "Category", align: "left", visible: true },
    SubCategory: { text: "Sub Category", align: "left", visible: true },
    Details: { text: "Details", align: "left", visible: true },
    FileName: {
      text: "Attachment",
      align: "start",
      type: "Link",
      visible: true,
    },
    ApplicationStatus_123: {
      text: "Status",
      align: "center",
      visible: true,
      type: "Select",
      option: [...requisitionOption],
    },
    TXNDate: { text: "Applied Date", align: "center", visible: true },
    ClosureDate: { text: "Closure Date", align: "center", visible: false },
    ActionByName: { text: "Action By", visible: false },
    ActionRemarks: { text: "Action Remarks", align: "left", visible: false },
  };

  useEffect(() => {
    fetchGetEmployeeAdminList();
  }, []); // Empty dependency array ensures it runs once on mount
  const [originalData, setOriginalData] = useState([]);


  // Apply URL filters
  useEffect(() => {
    if (originalData.length === 0) return;

    const queryParams = new URLSearchParams(location.search);
    const pAllocatedParam = queryParams.get('ApplicationStatus');
    const fdate = queryParams.get('FromDate');
    const tdate = queryParams.get('ToDate');
    console.log("fdate", fdate);

    console.log("fdate", fdate);

    const filteredData = originalData.filter(o => {
      const joinDate = moment(o.TXNDate, "YYYY-MM-DD");

      const fromCondition = fdate
        ? joinDate.isSameOrAfter(moment(fdate), 'day')
        : true;
      const ToCondition = tdate
        ? joinDate.isSameOrBefore(moment(tdate), 'day')
        : true;

      const Fstatus = pAllocatedParam
        ? o.ApplicationStatus?.trim()?.toLowerCase() == pAllocatedParam?.trim()?.toLowerCase()
        : true;

      return fromCondition && Fstatus && ToCondition;
    });

    console.log("filteredData", filteredData);
    setSuperAdminListData(filteredData);

  }, [location.search, originalData]);

  const fetchGetEmployeeAdminList = async () => {
    SetApiStatus(undefined)
    try {
      const queryParams = new URLSearchParams({
        admin: 1,
        fromDate: "",
        toDate: "",
        status: 0,
      }).toString();
      const response = await GetServiceCaller(
        `${API_URL}requisition/admin?${queryParams}`
      );
      SetApiStatus(response?.status);

      if (response?.status === 200) {
        const cleanedData = response?.data?.data || [];
        setSuperAdminListData(cleanedData);
        setOriginalData(cleanedData)
        const type = response?.data?.requisitionTypes?.map((ele, index) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setRequisitionOption(type);
      } else {
        console.error(
          "Failed to fetch Employee Admin List. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Employee Admin List:", error);
    } finally {
      setLoading(false); // Always stop loading, even if there's an error
    }
  };

  const handleEdit = (id) => {
    // navigate(`/admin/employee/edit/${id.ID}`)
    console.log("Editid", id);
  };

  const handleAddNewVendor = () => {
    navigate(`/admin/employee/add`);
  };

  const [filterFormData, setFilterData] = useState([]);
  const formDatas = [
    {
      name: "From Date",
      type: "Date",
    },
    {
      name: "To Date",
      type: "Date",
    },
    {
      name: "Type",
      type: "Select",
      options: [...(requisitionOption || [])],
    },
  ];

  const handleFilterChange = (e, name) => {
    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e?.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };
  const handleGetData = async () => {
    SetApiStatus(undefined)

    try {
      const queryParams = new URLSearchParams({
        admin: 1,
        fromDate: filterFormData.find((o) => o.label === "From Date")
          ? moment(
            filterFormData.find((o) => o.label === "From Date").value
          ).format("YYYY-MM-DD")
          : "",
        toDate: filterFormData.find((o) => o.label === "To Date")
          ? moment(
            filterFormData.find((o) => o.label === "To Date").value
          ).format("YYYY-MM-DD")
          : "",
        status: filterFormData.find((o) => o.label === "Type")
          ? filterFormData.find((o) => o.label === "Type").value
          : 0,
      }).toString();

      const response = await GetServiceCaller(
        `${API_URL}requisition/admin?${queryParams}`
      );

      SetApiStatus(response?.status);

      if (response.status === 200) {
        const cleanedData = response?.data?.data;
        setSuperAdminListData(cleanedData);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch Disposed Report. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Disposed Report:", error);
    }
  };

  const handleReset = () => {
    setFilterData([])
    fetchGetEmployeeAdminList();

  }

  const [showStatus, setShowStatus] = useState(false);
  const [reason, setReason] = useState("");
  const [newSelectedStatus, setNewSelectedStatus] = useState("");
  const [selectedItem, setSelectedItem] = useState([]);
  const handleColumnSelect = (columnName, item) => {
    setShowStatus(true);
    setSelectedItem(item);
    setNewSelectedStatus(columnName.value);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setReason(value);
  };

  const handleClose = () => {
    setShowStatus(false);
    setReason("");
  };
  const schema = yup.object().shape({
    reason: yup.string().required("Action Remarks is required"),
  });

  const handleSubmitStatus = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await schema.validate({ reason });
      setError(""); //

      const response = await PostServiceCaller(
        `${API_URL}requisition/change-status`,
        {
          Requisition: {
            ID: selectedItem.ID,
            ApplicationStatus_123: newSelectedStatus,
            ActionRemarks: reason,
          },
        },
        "post"
      );

      if (response.status === 200) {
        toast.success("Data submitted successfully");
        setShowStatus(false);
        setReason("");
        fetchGetEmployeeAdminList();
      } else {
        console.error(
          "Failed to submit data. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      if (error.name === "ValidationError") {
        setError(error.message); // Show Yup validation error
      } else {
        console.log("Catching the error", error);
      }
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <SuperAdminTable
              data={superAdminListData}
              columns={columns}
              itemsPerPage={10}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              isSorting={true}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              showIcon1={true}
              showIcon2={false}
              handleReset={handleReset}
              formDatas={formDatas}
              filterFormData={filterFormData}
              handleChange={handleFilterChange}
              handleGetData={handleGetData}
              handleColumnSelect={handleColumnSelect}
              isFilterRequired={true}
              isActionRequired={false}
              isAddNewBtnRequired={false}
              showIcon3={false}
              showIcon4={false}

              showIcon5={false}
              handleIcon1={handleEdit}
              handleAddNew={handleAddNewVendor}
              add
              more
              function
              icons={{
                Icon1: <i className="bi bi-pencil-square icons"></i>,
                Icon1Text: " Edit",
                Icon1Flag: "canEdit",
                Icon2: <i className="bi bi-trash-fill icons"></i>,
                Icon3: <i className="bi bi-eye-fill icons"></i>,
                Icon4: <i className="bi bi-plus-square icons"></i>,
                Icon4Text: " Add Sub-Contractor",
              }}
            />
          </div>
        </div>

        {/* 
                <Modal
                    show={showStatus}
                    onHide={handleClose}
                    dialogClassName="modal-md"
                    centered
                >
                    <div
                        style={{ backgroundColor: "#F2F2F4" }}
                        className="card rounded border-0 m-2"
                    >
                        <Modal.Header scloseButton>
                            <Modal.Title className="text-info">
                                <div className="text-center d-flex justify-center">
                                    <h2 style={{ fontWeight: "800", color: "#2F2E4B" }}>
                                        Confirm
                                    </h2>
                                </div>
                            </Modal.Title>
                        </Modal.Header>

                        <Modal.Body
                            className="rounded m-3"
                            style={{
                                maxHeight: "60vh",
                                overflow: "scroll",
                                backgroundColor: "white",
                            }}
                        >
                            <div>
                                <label className='form-label'> Action Remarks</label>
                            </div>
                            <div>

                                <textarea name='reason' className='form-control' onChange={handleChange} value={reason} />
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button className="custom-btn" onClick={handleClose}>
                                No
                            </Button>
                            <Button
                                disabled={loading ? true : false}
                                type="button"
                                className="custom-btn"
                                onClick={handleSubmitStatus}
                            >
                                {loading ? <FaSpinner class="sm-spinner" /> : "Yes"}
                            </Button>
                        </Modal.Footer>
                    </div>
                </Modal> */}

        {showStatus && (
          <div
            className="modal"
            tabIndex="-1"
            role="dialog"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 1050
            }}
          >
            <div
              className="modal-dialog modal-sm"
              role="document"
              style={{
                width: "300px", // Standard width for modal-sm
                margin: 0 // Remove default margin
              }}
            >
              <div className="modal-content">
                <div className="modal-header" style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  borderBottom: '1px solid #f0f0f0',
                  backgroundColor: '#f8f9fa',
                  borderRadius: '8px 8px 0 0'
                }}>
                  <p style={{
                    fontSize: '16px',
                    fontWeight: '600',
                    color: '#27568B',
                    margin: '0'
                  }}>Confirm</p>
                  <span className="me-2">
                    <i className="bi bi-x-lg" onClick={handleClose}></i>
                  </span>
                </div>
                <div className="modal-body p-2">
                  <div>
                    <label className="form-label">
                      {" "}
                      Action Remarks<span className="required">*</span>
                    </label>
                  </div>
                  <div>
                    <textarea
                      name="reason"
                      className={`form-control ${error ? "is-invalid" : ""}`}
                      onChange={handleChange}
                      value={reason}
                    />
                    {error && <div className="text-danger">{error}</div>}
                  </div>

                  <div className="text-end mt-2">
                    <Button className="cancel-btn-sm me-2" onClick={handleClose}>
                      No
                    </Button>
                    <Button
                      disabled={loading ? true : false}
                      type="button"
                      className="custom-btn-sm"
                      onClick={handleSubmitStatus}
                    >
                      {loading ? <FaSpinner class="sm-spinner" /> : "Yes"}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default SuperAdminList;
